import { IMedicationLogisticsStore } from './types';

const initStore: IMedicationLogisticsStore = {
  current: null,
  list: [],
  monitoredBy: [],
};

export default initStore;
